import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {SharedModule} from '../../../../core/modules/shared.module';
import {EditOrganisationDialogComponent} from './edit.organisation.dialog.component';

const routes =
    [{path: 'userdialog', component: EditOrganisationDialogComponent}];

@NgModule({
  declarations: [EditOrganisationDialogComponent],
  imports: [SharedModule, RouterModule.forChild(routes)],
  exports: [EditOrganisationDialogComponent]
})

export class EditOrganistationModule {}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/organisations/edit/edit.organisation.dialog.module.ts